<template>
  <!-- 国际选择国家弹窗 -->
  <mt-popup position="bottom"
            v-model="visible"
            :closeOnClickModal="false"
            class="g-bottom-popup">
    <div class="popup-container">
      <div class="popup-top">
        <span class="title"
              :style="[{ textAlign: 'center' }]">国家</span>
        <i class="iconfont icon-close"
            @click="() => close()" />
      </div>
      <div class="popup-main">
        <div class="intCountry-popup">
          <div class="top-search">
            <div class="search-input">
              <i class="iconfont icon-search btn-search" :class="PostUiIcon.search" />
              <input ref="searchInput"
                     v-model.trim="search"
                     type="text"
                     placeholder="请输国家名称搜索"
                     @input="handlerSearch()">
              <i v-show="search"
                 class="iconfont icon-close-circle btn-clear"
                 @click.stop="() => { search = '' }" />
            </div>
            <!-- <button v-if="search"
                    type="button"
                    class="btn-confirm"
                    @click="handlerSearch()">
              搜索
            </button> -->
          </div>
          <div class="intCountry-container">
            <div v-if="!search" class="tabs-box">
              <div class="tabs-item" :class="{'is-active' : tabActive === '1' }" @click="tabActive = '1'">
                <span>热门国家</span>
              </div>
              <div class="tabs-item" :class="{'is-active' : tabActive === '2' }" @click="tabActive = '2'">
                <span>常用国家</span>
              </div>
            </div>
            <div v-if="tabActive === '1' && hotCountries.length && !search" class="popular-wrap">
              <ul class="popular-list">
                <li v-for="(item, index) in hotCountries"
                  :key="index"
                  class="popular-item"
                  @click="handleHotCountries(item.countryName)">
                  {{ item.countryName }}
                </li>
              </ul>
              <div class="line" />
            </div>
            <div v-if="tabActive === '1'" class="intCountry-list">
              <div class="country-item"
                  :class="{ 'active': selectItem === item.countryNameEg }"
                   v-for="(item,index) in countryData"
                   :key="index"
                   @click="handlerSelect(item)">
                   <span class="char-style">{{ index === 0 ? item.countryInitials : '' }}
                    {{ (index !== 0 && (countryData[index].countryInitials !== countryData[index - 1].countryInitials)) ?
                      item.countryInitials : '' }}
                    </span>
                   <p v-html="highlightText(item.text, search)"></p>
                   <!-- <p>{{ item.countryName }} {{ item.countryNameEg }}</p> -->
                   <i class="iconfont"
                   :class="selectItem === item.countryNameEg ? 'icon-check-circle' : 'icon-check-button-off'" />
                  </div>
              <!-- 缺省图 -->
              <no-result-box v-if="!countryData.length" resultNull="查无国家信息"></no-result-box>
            </div>
            <div v-else-if="tabActive === '2'" class="intCountry-list">
              <div class="country-item"
                  :class="{ 'active': selectItem === item.countryNameEg }"
                   v-for="(item,index) in countryCache"
                   :key="index"
                   @click="handlerSelect(item)">
                   <!-- <span class="char-style">{{ item.headChar }}</span> -->
                   <p>{{ item.countryName }} {{ item.countryNameEg }}</p>
                   <i class="iconfont"
                   :class="selectItem === item.countryNameEg ? 'icon-check-circle' : 'icon-check-button-off'" />
                  </div>
              <!-- 缺省图 -->
              <no-result-box v-if="!countryCache.length" resultNull="暂无国家信息"></no-result-box>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="confirmBtn"
            class="popup-bottom"
            :style="{ padding: safeAreaInsetBottom ? '0.16rem 0.28rem 0.76rem' : '0.16rem 0.28rem' }">
        <button type="button"
                class="confirm-btn"
                @click="$emit('confirm')">
          {{ confirmBtnText }}
        </button>
      </div> -->
    </div>
  </mt-popup>
</template>

<script>
import NoResultBox from '@/components/noResult/NoResultBox.vue'
import { highlightText, debounce } from '@/plugin/commonUse.js'
import { Popup } from 'mint-ui'
export default {
  name: '',
  mixins: [],
  components: {
    NoResultBox,
    'mt-popup': Popup
  },
  model: {
    prop: 'visible',
    event: 'change'
  },
  props: {
    visible: {
      default: false
    },
    selectItem: {
      type: String,
      default: ''
    },
    hotCountries: {
      type: Array,
      default: () => []
    },
    intCountryData: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      search: '',
      tabActive: '',
      countryData: []
    }
  },
  computed: {
    countryCache () {
      if (!window.localStorage.getItem('countryCache')) {
        return []
      }
      let list = JSON.parse(window.localStorage.getItem('countryCache'))
      for (let item of list) {
        if (item.cnName) { // 兼容旧缓存
          item.countryName = item.cnName
          item.countryNameEg = item.enName
          item.countryCode = item.enAbbr
        }
      }
      return list
    },
    highlightText () {
      return highlightText
    }
  },
  watch: {
    search (val) {
      if (!val) {
        // 结束搜索
        this.countryData = this.intCountryData.map((value) => {
          return {
            ...value,
            text: `${value.countryName} ${value.countryNameEg}`
          }
        })
      }
    },
    visible (val) {
      if (val) {
        this.tabActive = '1'

        this.countryData = this.intCountryData.map((value) => {
          return {
            ...value,
            text: `${value.countryName} ${value.countryNameEg}` // 方便搜索高亮
          }
        })
      }
    }
  },
  filters: {},
  directives: {},
  created () {},
  mounted () {
  },
  methods: {
    // 搜索
    handlerSearch: debounce(function () {
      let searchText = this.search.toUpperCase()
      this.countryData = this.countryData.filter((value) => value.text.includes(searchText))
      this.tabActive = '1'
    }, 750),
    // 选择热门
    handleHotCountries (countryName) {
      const findObj = this.intCountryData.find((value) => value.countryName === countryName)
      this.$emit('select', findObj)
      this.close()
    },
    // 选中
    handlerSelect (data) {
      const obj = { ...data }
      delete obj['text']
      let list = JSON.parse(window.localStorage.getItem('countryCache')) || []
      let findIn = list.findIndex((item) => item.countryName === obj.countryName)
      if (findIn === -1) {
        list.push(obj) // 新的
        window.localStorage.setItem('countryCache', JSON.stringify(list))
      }
      this.$emit('select', obj)
      this.close()
    },
    // 关闭
    close () {
      this.search = ''
      this.$emit('change', false)
    }
  }
}
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
